<div class="assistant-ring"></div>
